import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Store,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}stores`;

export interface GetStoreByExternalIdQueryArgs {
  externalId: string;
  sellerId?: string;
}

const getStoreByExternalIdQuery = async ({
  externalId,
  sellerId,
}: GetStoreByExternalIdQueryArgs): Promise<
  BackResponse<Store> | BackResponseFailure
> => {
  try {
    const url = `${ENDPOINT}/${externalId}`;
    const finalUrl = sellerId ? buildUrl(url, { SellerId: sellerId }) : url;

    return await apiCall<BackResponse<Store>>(finalUrl, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getStoreByExternalIdQuery;
